export var K8s360Subjects;
(function (K8s360Subjects) {
    K8s360Subjects["Footer"] = "footerContainer";
    K8s360Subjects["Card"] = "cardContainer";
    K8s360Subjects["App"] = "kube360App";
    K8s360Subjects["QuickView"] = "quickView";
    K8s360Subjects["QuickViewTitle"] = "quickViewTitle";
    K8s360Subjects["QuickViewType"] = "fieldRowTypeWrapper";
    K8s360Subjects["CloseQuickView"] = "closeQuickView";
    K8s360Subjects["LegendMetricTypePrefix"] = "legendMetricType-";
    K8s360Subjects["CirclePrefix"] = "circle-";
    K8s360Subjects["LegendNumberPrefix"] = "legendNumber-";
    K8s360Subjects["LoadingKubeMapCard"] = "loadingKubeMapCard";
    K8s360Subjects["GroupPodsByTypeSelector"] = "groupPodsByTypeSelector";
    K8s360Subjects["SwitchViewMode"] = "switchViewMode";
    K8s360Subjects["OverviewCardRow"] = "overview-cart-row";
    K8s360Subjects["OverviewCardRowLabel"] = "overview-cart-row-label";
    K8s360Subjects["OverviewCardRowValue"] = "overview-cart-row-value";
    K8s360Subjects["EmptyStateTitle"] = "empty-state-title";
    K8s360Subjects["EmptyStateText"] = "empty-state-text";
})(K8s360Subjects || (K8s360Subjects = {}));
export var K8SQuickViewTabNames;
(function (K8SQuickViewTabNames) {
    K8SQuickViewTabNames["PODS"] = "Pods";
    K8SQuickViewTabNames["LOGS"] = "Logs";
    K8SQuickViewTabNames["SECURITY"] = "Security";
    K8SQuickViewTabNames["METRICS"] = "Metrics";
    K8SQuickViewTabNames["TRACES"] = "Traces";
    K8SQuickViewTabNames["YAML"] = "YAML";
})(K8SQuickViewTabNames || (K8SQuickViewTabNames = {}));
export var K8sPodStatus;
(function (K8sPodStatus) {
    K8sPodStatus["Failed"] = "failed";
    K8sPodStatus["Pending"] = "pending";
    K8sPodStatus["Running"] = "running";
})(K8sPodStatus || (K8sPodStatus = {}));
export var K8sSortDirection;
(function (K8sSortDirection) {
    K8sSortDirection["ASC"] = "ASC";
    K8sSortDirection["DESC"] = "DESC";
})(K8sSortDirection || (K8sSortDirection = {}));
//# sourceMappingURL=k8s360.enum.js.map